module.exports = __webpack_public_path__ + "static/nxrt-esports-7-51d66d5d8d9ef4fac0b420f5c88383d4.png";